import ManufacturersRequests from '../../server/manufacturers';
import { addLoading, removeLoading } from './loading';

const setManufacturers = manufacturers => ({
  type: 'GET_MANUFACTURERS',
  manufacturers,
});

const setManufacturer = manufacturer => ({
  type: 'GET_MANUFACTURER',
  manufacturer,
});


const getManufacturers = (limit, skip, search = '', order = '', field = '') => async (dispatch) => {
  dispatch(addLoading());
  try {
    const manufacturers = await ManufacturersRequests.getManufacturers(limit, skip, search, order, field);
    dispatch(setManufacturers(manufacturers));
  } finally {
    dispatch(removeLoading());
  }
};

const getManufacturer = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    const manufacturer = await ManufacturersRequests.getManufacturer(id);
    dispatch(setManufacturer(manufacturer));
  } finally {
    dispatch(removeLoading());
  }
};

const createManufacturer = manufacturer => async (dispatch) => {
  dispatch(addLoading());
  try {
    await ManufacturersRequests.createManufacturer(manufacturer);
  } finally {
    dispatch(removeLoading());
  }
};

const updateManufacturer = manufacturer => async (dispatch) => {
  dispatch(addLoading());
  try {
    await ManufacturersRequests.updateManufacturer(manufacturer);
  } finally {
    dispatch(removeLoading());
  }
};

const deleteManufacturer = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    await ManufacturersRequests.deleteManufacturer(id);
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvManufacturerModel = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await ManufacturersRequests.getCsvManufacturerModel();
  } finally {
    dispatch(removeLoading());
  }
};

const getCsvManufacturersReport = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await ManufacturersRequests.getCsvManufacturersReport();
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadManufacturersCsv = file => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await ManufacturersRequests.uploadCsvManufacturers(file);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};

const uploadManufacturer = async (file, name, id) => ManufacturersRequests.uploadManufacturer(file, name, id);

export default {
  getManufacturers,
  getManufacturer,
  createManufacturer,
  deleteManufacturer,
  updateManufacturer,
  uploadManufacturer,
  getCsvManufacturersReport,
};
